import _classCallCheck from "/opt/build/repo/example/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _possibleConstructorReturn from "/opt/build/repo/example/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/opt/build/repo/example/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/opt/build/repo/example/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import { __rest } from "tslib";
import * as React from 'react';
import styles from '@patternfly/react-styles/css/components/ClipboardCopy/clipboard-copy';
import { css } from '@patternfly/react-styles';
import { TextInput } from '../TextInput';
import { TooltipPosition } from '../Tooltip';
import { GenerateId } from '../../helpers/GenerateId/GenerateId';
import { ClipboardCopyButton } from './ClipboardCopyButton';
import { ClipboardCopyToggle } from './ClipboardCopyToggle';
import { ClipboardCopyExpanded } from './ClipboardCopyExpanded';
export var clipboardCopyFunc = function clipboardCopyFunc(event, text) {
  var clipboard = event.currentTarget.parentElement;
  var el = document.createElement('input');
  el.value = text.toString();
  clipboard.appendChild(el);
  el.select();
  document.execCommand('copy');
  clipboard.removeChild(el);
};
export var ClipboardCopyVariant;

(function (ClipboardCopyVariant) {
  ClipboardCopyVariant["inline"] = "inline";
  ClipboardCopyVariant["expansion"] = "expansion";
})(ClipboardCopyVariant || (ClipboardCopyVariant = {}));

export var ClipboardCopy =
/*#__PURE__*/
function (_React$Component) {
  _inherits(ClipboardCopy, _React$Component);

  function ClipboardCopy(props) {
    var _this;

    _classCallCheck(this, ClipboardCopy);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ClipboardCopy).call(this, props));
    _this.timer = null; // eslint-disable-next-line @typescript-eslint/no-unused-vars

    _this.componentDidUpdate = function (prevProps, prevState) {
      if (prevProps.children !== _this.props.children) {
        _this.updateText(_this.props.children);
      }
    }; // eslint-disable-next-line @typescript-eslint/no-unused-vars


    _this.expandContent = function (_event) {
      _this.setState(function (prevState) {
        return {
          expanded: !prevState.expanded
        };
      });
    };

    _this.updateText = function (text) {
      _this.setState({
        text: text
      });

      _this.props.onChange(text);
    };

    _this.render = function () {
      var _a = _this.props,
          isExpanded = _a.isExpanded,
          onChange = _a.onChange,
          isReadOnly = _a.isReadOnly,
          isCode = _a.isCode,
          exitDelay = _a.exitDelay,
          maxWidth = _a.maxWidth,
          entryDelay = _a.entryDelay,
          switchDelay = _a.switchDelay,
          onCopy = _a.onCopy,
          hoverTip = _a.hoverTip,
          clickTip = _a.clickTip,
          textAriaLabel = _a.textAriaLabel,
          toggleAriaLabel = _a.toggleAriaLabel,
          variant = _a.variant,
          position = _a.position,
          className = _a.className,
          divProps = __rest(_a, ["isExpanded", "onChange", "isReadOnly", "isCode", "exitDelay", "maxWidth", "entryDelay", "switchDelay", "onCopy", "hoverTip", "clickTip", "textAriaLabel", "toggleAriaLabel", "variant", "position", "className"]);

      var textIdPrefix = 'text-input-';
      var toggleIdPrefix = 'toggle-';
      var contentIdPrefix = 'content-';
      return React.createElement("div", Object.assign({
        className: css(styles.clipboardCopy, _this.state.expanded && styles.modifiers.expanded, className)
      }, divProps), React.createElement(GenerateId, {
        prefix: ""
      }, function (id) {
        return React.createElement(React.Fragment, null, React.createElement("div", {
          className: css(styles.clipboardCopyGroup)
        }, variant === 'expansion' && React.createElement(ClipboardCopyToggle, {
          isExpanded: _this.state.expanded,
          onClick: _this.expandContent,
          id: "".concat(toggleIdPrefix, "-").concat(id),
          textId: "".concat(textIdPrefix, "-").concat(id),
          contentId: "".concat(contentIdPrefix, "-").concat(id),
          "aria-label": toggleAriaLabel
        }), React.createElement(TextInput, {
          isReadOnly: isReadOnly || _this.state.expanded,
          onChange: _this.updateText,
          value: _this.state.text,
          id: "text-input-".concat(id),
          "aria-label": textAriaLabel
        }), React.createElement(ClipboardCopyButton, {
          exitDelay: exitDelay,
          entryDelay: entryDelay,
          maxWidth: maxWidth,
          position: position,
          id: "copy-button-".concat(id),
          textId: "text-input-".concat(id),
          "aria-label": hoverTip,
          onClick: function onClick(event) {
            if (_this.timer) {
              window.clearTimeout(_this.timer);

              _this.setState({
                copied: false
              });
            }

            onCopy(event, _this.state.text);

            _this.setState({
              copied: true
            }, function () {
              _this.timer = window.setTimeout(function () {
                _this.setState({
                  copied: false
                });

                _this.timer = null;
              }, switchDelay);
            });
          }
        }, _this.state.copied ? clickTip : hoverTip)), _this.state.expanded && React.createElement(ClipboardCopyExpanded, {
          isReadOnly: isReadOnly,
          isCode: isCode,
          id: "content-".concat(id),
          onChange: _this.updateText
        }, _this.state.text));
      }));
    };

    _this.state = {
      text: _this.props.children,
      expanded: _this.props.isExpanded,
      copied: false
    };
    return _this;
  }

  return ClipboardCopy;
}(React.Component);
ClipboardCopy.defaultProps = {
  hoverTip: 'Copy to clipboard',
  clickTip: 'Successfully copied to clipboard!',
  isReadOnly: false,
  isExpanded: false,
  isCode: false,
  variant: 'inline',
  position: TooltipPosition.top,
  maxWidth: '150px',
  exitDelay: 1600,
  entryDelay: 100,
  switchDelay: 2000,
  onCopy: clipboardCopyFunc,
  onChange: function onChange() {
    return undefined;
  },
  textAriaLabel: 'Copyable input',
  toggleAriaLabel: 'Show content'
};